import mixins from 'vue-typed-mixins';
import _ from 'lodash';

import InputableText from '@/components/inputableText/InputableText.vue';

import InputableTextBaseMixin from '@/entries/user/mixins/InputableTextBaseMixin';
import KeystrokeInputableTextMixin from '@/entries/user/mixins/KeystrokeInputableTextMixin';
import KeystrokePropsMixin from '@/entries/user/mixins/KeystrokePropsMixin';

export type KeystrokeInputableTextId = Record<string, number>;

enum KeyAction {
  up,
  down,
  left,
  right,
}

export default mixins(InputableTextBaseMixin, KeystrokeInputableTextMixin, KeystrokePropsMixin).extend({
  name: 'KeystrokeInputableText',

  components: {
    InputableText,
  },

  data(): {
    readonly keyAction: typeof KeyAction;
  } {
    return {
      keyAction: KeyAction,
    };
  },

  computed: {
    isActive(): boolean {
      return _.isEqual(this.id, this.keystrokeInputableTextId);
    },
  },

  methods: {
    focus(): void {
      this.setKeystrokeId(this.id);
    },
    moveCursor(keyAction: KeyAction): void {
      if (this.map.length === 0 || this.keystrokeInputableTextId === null) return;
      switch (keyAction) {
        case KeyAction.up:
          this.$_move(0, -1);
          break;
        case KeyAction.down:
          this.$_move(0, 1);
          break;
        case KeyAction.left:
          this.$_move(-1, 0);
          break;
        case KeyAction.right:
          this.$_move(1, 0);
          break;
      }
    },
    $_move(diffX: -1 | 0 | 1, diffY: -1 | 0 | 1): void {
      // 現在のカーソル位置を取得
      const map = this.map;
      const index = { x: -1, y: -1 };
      for (index.y = 0; index.y < map.length; index.y++) {
        const ids = map[index.y];
        const foundX = ids.findIndex((c) => _.isEqual(c, this.keystrokeInputableTextId));
        if (foundX !== -1) {
          index.x = foundX;
          break;
        }
      }
      if (index.x === -1) return;
      // 移動
      const validate = (index: number, length: number): number => {
        if (index < 0) return length - 1;
        if (index >= length) return 0;
        return index;
      };
      if (diffX !== 0) {
        while (true) {
          index.x = validate(index.x + diffX, map[index.y].length);
          if (!_.isNil(map[index.y][index.x])) break;
        }
      }
      if (diffY !== 0) {
        while (true) {
          index.y = validate(index.y + diffY, map.length);
          if (!_.isNil(map[index.y][index.x])) break;
        }
      }
      this.setKeystrokeId(map[index.y][index.x]);
    },
  },
});
